module.exports = __webpack_public_path__ + "media/images/disable_next-ebc575908f9e4e7a9c3514c340b62538.png";